<app-content-card [title]="isPersonProfile() ? null : 'Mi perfil'">
  <section class="flex flex-column gap-3" data-testid="perfil-shell">
    @if (!isPersonProfile()) {
      <p class="m-0 text-color-secondary" data-testid="perfil-mi-perfil">
        Vista del nav Perfil. La ficha de otra persona esta en /perfil/:id (Congregacion).
      </p>
      <a routerLink="/configuracion/mi-cuenta" class="text-primary mt-2 inline-block">
        Ir a Configuracion &gt; Mi cuenta
      </a>
    } @else if (loading()) {
      <div data-testid="perfil-loading">
        <app-skeleton-block variant="profile" />
      </div>
    } @else if (loadError()) {
      <p class="m-0 text-red-500" data-testid="perfil-error">{{ loadError() }}</p>
    } @else if (person()) {
      <div
        class="flex align-items-center justify-content-between flex-wrap gap-2 mb-1"
        data-testid="perfil-header"
      >
        <h1 class="m-0 text-xl font-medium text-color">Perfil</h1>
        <div class="flex align-items-center">
          <p-button
            type="button"
            icon="pi pi-ellipsis-v"
            [rounded]="true"
            [text]="true"
            (onClick)="menu.toggle($event)"
            ariaLabel="Acciones del perfil"
            data-testid="perfil-acciones"
          />
          <p-menu #menu [model]="menuItems()" [popup]="true" appendTo="body" />
        </div>
      </div>

      <div class="grid">
        <!-- Datos personales (Admin + Lider) — bloque original -->
        <div class="col-12 lg:col-4">
          <p-card styleClass="h-full" data-testid="perfil-datos">
            <h2 class="m-0 mb-1 text-lg font-medium">Datos personales</h2>
            <p class="m-0 mb-3 text-sm text-color-secondary">Informacion de la persona</p>
            <div
              class="flex align-items-center gap-3 py-2 mb-2"
              data-testid="perfil-datos-stub"
            >
              <p-avatar
                [label]="initials()"
                shape="circle"
                [style]="avatarStyle()"
                [image]="person()!.img || undefined"
              />
              <div class="flex flex-column justify-content-center gap-1">
                <span class="text-xl font-semibold text-color line-height-2">{{ displayName() }}</span>
                <span class="text-color-secondary text-sm">
                  Lider: {{ leaderLabel() }}
                </span>
              </div>
            </div>
            <div class="flex flex-column gap-2 text-sm mt-2">
              <p class="m-0">
                <span class="font-bold text-color">Edad: </span>{{ person()!.nacimiento | edad }}
              </p>
              <p class="m-0">
                <span class="font-bold text-color">Fecha de nacimiento: </span>{{ fechaNacimiento() }}
              </p>
              <p class="m-0">
                <span class="font-bold text-color">Localidad: </span>{{ emptyOr(localidadLabel()) }}
              </p>
              <p class="m-0" data-testid="perfil-ministerio">
                <span class="font-bold text-color">Ministerio: </span>{{ emptyOr(ministerioLabel()) }}
              </p>
              <p class="m-0">
                <span class="font-bold text-color">E-mail: </span>{{ emptyOr(person()!.email) }}
              </p>
              <p class="m-0" data-testid="perfil-faltas">
                <span class="font-bold text-color">Faltas dominicales: </span>{{ faltasLabel() }}.
              </p>
              <p class="m-0">
                <span class="font-bold text-color">Celular: </span>
                @if (whatsappUrl(); as wa) {
                  <a [href]="wa" target="_blank" rel="noopener">{{ person()!.celular }}</a>
                } @else {
                  {{ emptyOr(person()!.celular) }}
                }
              </p>
              <p class="m-0">
                <span class="font-bold text-color">Direccion: </span>
                @if (mapsUrl(); as maps) {
                  <a [href]="maps" target="_blank" rel="noopener">{{ person()!.direccion }}</a>
                } @else {
                  {{ emptyOr(person()!.direccion) }}
                }
              </p>
              <p class="m-0">
                <span class="font-bold text-color">Bautismo: </span>{{ bautismoLabel() }}
              </p>
              @if (person()!.estudiando) {
                <p class="m-0 mt-2 text-color-secondary">Actualmente se encuentra estudiando.</p>
              }
            </div>
          </p-card>
        </div>

        <div class="col-12 lg:col-8">
          <p-card styleClass="h-full" data-testid="perfil-asistencia">
            <h2 class="m-0 mb-1 text-lg font-medium">Asistencia</h2>
            <p class="m-0 mb-3 text-sm text-color-secondary">Ultimas 5 semanas</p>
            @if (showReunionSelect()) {
              <div class="flex flex-column gap-2 mb-3" style="max-width: 20rem" data-testid="perfil-reunion">
                <label class="text-sm font-medium" for="reunion-select">Reunion a la que asiste</label>
                <p-select
                  inputId="reunion-select"
                  [options]="reunionOptions()"
                  optionLabel="label"
                  optionValue="value"
                  [ngModel]="person()!.reunionSelect ?? 0"
                  (ngModelChange)="onReunionChange($event)"
                  appendTo="body"
                  styleClass="w-full"
                />
              </div>
            }
            @if (asistenciaLoading()) {
              <div class="mb-2" data-testid="perfil-asistencia-loading">
                <app-skeleton-block variant="chart" />
              </div>
            }
            @if (asistenciaError()) {
              <p class="m-0 mb-2 text-sm text-red-500" data-testid="perfil-asistencia-error">
                {{ asistenciaError() }}
              </p>
            }
            <h3 class="m-0 mb-2 text-base font-medium">Historial de asistencia</h3>
            <div class="overflow-auto">
              <table class="w-full text-sm text-center" data-testid="perfil-asistencia-tabla">
                <thead>
                  <tr>
                    <th class="text-left font-medium p-2">Fechas</th>
                    @for (semana of semanas(); track semana.iso) {
                      <th class="font-medium p-2" data-testid="perfil-asistencia-fecha">{{ semana.label }}</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left p-2">Domingo</td>
                    @for (semana of semanas(); track semana.iso) {
                      <td class="p-2" data-testid="perfil-asistencia-domingo">
                        @if (semana.marca) {
                          <i
                            class="pi perfil-marca"
                            [class.pi-check]="semana.marca.domingo"
                            [class.pi-times]="!semana.marca.domingo"
                            [class.perfil-marca--ok]="semana.marca.domingo"
                            [class.perfil-marca--no]="!semana.marca.domingo"
                            [attr.aria-label]="semana.marca.domingo ? 'Asistió' : 'No asistió'"
                          ></i>
                        } @else {
                          <span>Sin informar</span>
                        }
                      </td>
                    }
                  </tr>
                  <tr>
                    <td class="text-left p-2">Celula</td>
                    @for (semana of semanas(); track semana.iso) {
                      <td class="p-2" data-testid="perfil-asistencia-celula">
                        @if (semana.marca) {
                          <i
                            class="pi perfil-marca"
                            [class.pi-check]="semana.marca.celula"
                            [class.pi-times]="!semana.marca.celula"
                            [class.perfil-marca--ok]="semana.marca.celula"
                            [class.perfil-marca--no]="!semana.marca.celula"
                            [attr.aria-label]="semana.marca.celula ? 'Asistió a célula' : 'No asistió a célula'"
                          ></i>
                        } @else {
                          <span>Sin informar</span>
                        }
                      </td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
          </p-card>
        </div>

        <!-- Permisos / Liderazgo — solo Admin (mayorap2); Lider ve aviso -->
        @if (isAdminViewer()) {
          <div class="col-12 md:col-6">
            <p-card data-testid="perfil-permisos">
              <h2 class="m-0 mb-1 text-lg font-medium">Permisos</h2>
              <p class="m-0 mb-3 text-sm text-color-secondary">Datos administrativos</p>
              <p class="m-0 mb-3 font-medium text-primary">
                {{ emptyOr(person()!.mailAccess, person()!.email) }}
              </p>
              <div class="flex flex-column gap-2">
                <div class="flex align-items-center gap-2">
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="person()!.admin"
                    [disabled]="true"
                    inputId="perm-admin"
                  />
                  <label for="perm-admin">{{
                    person()!.admin ? 'Administrador' : 'No es administrador'
                  }}</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="person()!.lider"
                    [disabled]="true"
                    inputId="perm-lider"
                  />
                  <label for="perm-lider">{{
                    person()!.lider ? 'Es Lider' : 'No es Lider'
                  }}</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="person()!.contador"
                    [disabled]="true"
                    inputId="perm-contador"
                  />
                  <label for="perm-contador">{{
                    person()!.contador ? 'Es Contador' : 'No es contador'
                  }}</label>
                </div>
              </div>
            </p-card>
          </div>
          <div class="col-12 md:col-6">
            <p-card data-testid="perfil-liderazgo">
              <div class="flex align-items-center justify-content-between gap-2 mb-1">
                <h2 class="m-0 text-lg font-medium">Liderazgo</h2>
                @if (puedeTransferir()) {
                  @if (!modoTransferir()) {
                    <p-button
                      type="button"
                      label="Transferir"
                      [text]="true"
                      size="small"
                      (onClick)="empezarTransferencia()"
                      data-testid="perfil-transferir"
                    />
                  } @else {
                    <div class="flex align-items-center gap-1">
                      <p-button
                        type="button"
                        icon="pi pi-times"
                        [rounded]="true"
                        [text]="true"
                        severity="secondary"
                        ariaLabel="Cancelar transferencia"
                        (onClick)="cancelarTransferencia()"
                        data-testid="perfil-transferir-cancelar"
                      />
                      <p-button
                        type="button"
                        label="Enviar a"
                        size="small"
                        [disabled]="seleccion().length === 0"
                        (onClick)="abrirEnviar()"
                        data-testid="perfil-enviar"
                      />
                    </div>
                  }
                }
              </div>
              <p class="m-0 mb-3 text-sm text-color-secondary">Personas a cargo</p>
              @if (person()!.contactadoNombre && person()!.contactadoNombre !== 'nadie') {
                <p class="m-0 mb-2 text-sm">
                  Contactada por:
                  <span class="font-medium">{{ formatTextoPropio(person()!.contactadoNombre) }}</span>
                </p>
              }
              @if (!person()!.lider) {
                <p class="m-0 text-color-secondary" data-testid="perfil-liderazgo-stub">
                  No es lider
                </p>
              } @else if (discipulos().length === 0) {
                <p class="m-0 text-color-secondary" data-testid="perfil-celula-vacia">
                  Actualmente tiene su celula vacia
                </p>
              } @else {
                <p class="m-0 mb-2 text-sm font-medium">Lider de:</p>
                <div class="flex flex-column gap-2">
                  @for (discipulo of discipulos(); track discipulo.id) {
                    <div class="flex align-items-center gap-2">
                      @if (modoTransferir()) {
                        <p-checkbox
                          [binary]="true"
                          [ngModel]="estaSeleccionado(discipulo.id)"
                          (ngModelChange)="toggleDiscipulo(discipulo.id, $event)"
                          [inputId]="'transferir-' + discipulo.id"
                        />
                      }
                      @if (isAdminViewer() && !modoTransferir()) {
                        <a class="text-primary" [routerLink]="['/perfil', discipulo.id]">
                          {{ nombrePersona(discipulo) }}
                        </a>
                      } @else if (modoTransferir()) {
                        <label class="m-0" [attr.for]="'transferir-' + discipulo.id">
                          {{ nombrePersona(discipulo) }}
                        </label>
                      } @else {
                        <span>{{ nombrePersona(discipulo) }}</span>
                      }
                    </div>
                  }
                </div>
              }
            </p-card>
          </div>
        } @else if (isLiderViewer()) {
          <div class="col-12">
            <p-card>
              <p class="m-0 text-color-secondary" data-testid="perfil-admin-only-msg">
                Las tarjetas de permisos y liderazgo solo las ve un administrador.
              </p>
            </p-card>
          </div>
        }
      </div>
    }
  </section>
</app-content-card>

<p-dialog
  header="Cambiar imagen"
  [modal]="true"
  [style]="{ width: '28rem' }"
  [visible]="photoDialogOpen()"
  (visibleChange)="photoDialogOpen.set($event)"
>
  <p class="m-0 mb-3 text-sm text-color-secondary">
    Seleccione la imagen de perfil (crop completo en SCRUM-102).
  </p>
  @if (photoPreview()) {
    <div class="flex justify-content-center mb-3">
      <img
        [src]="photoPreview()!"
        alt="Vista previa"
        class="border-circle"
        style="width: 8rem; height: 8rem; object-fit: cover"
      />
    </div>
  }
  <input type="file" accept="image/*" (change)="onPhotoFileSelected($event)" class="mb-3 w-full" />
  <div class="flex justify-content-end gap-2">
    <p-button label="Cancelar" [text]="true" (onClick)="photoDialogOpen.set(false)" />
    <p-button label="Aplicar cambio" (onClick)="applyPhotoChange()" [disabled]="!photoPreview()" />
  </div>
</p-dialog>

<p-confirmDialog [style]="{ width: 'min(100%, 28rem)' }" />

<p-dialog
  [visible]="dialogoEnviar()"
  (visibleChange)="onDialogoEnviarVisible($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '32rem' }"
  header="Enviar a"
>
  <p class="m-0 mb-3 text-sm text-color-secondary">
    Elegí el líder que va a recibir
    {{ seleccion().length === 1 ? 'a la persona seleccionada' : 'a las ' + seleccion().length + ' personas seleccionadas' }}.
  </p>

  <label class="text-sm font-semibold text-color" for="perfil-lider-destino">Nuevo líder</label>
  <p-select
    inputId="perfil-lider-destino"
    [options]="lideresOpciones()"
    optionLabel="label"
    optionValue="value"
    placeholder="Elegí un líder"
    [filter]="lideresOpciones().length > 6"
    filterPlaceholder="Buscar líder"
    appendTo="body"
    styleClass="w-full mt-1"
    [loading]="cargandoLideres()"
    [ngModel]="liderDestino()"
    (ngModelChange)="liderDestino.set($event)"
    [disabled]="cargandoLideres() || enviando()"
  />

  @if (!cargandoLideres() && lideresOpciones().length === 0) {
    <p class="mt-2 mb-0 text-sm text-color-secondary">
      No hay otros líderes para recibir a estas personas.
    </p>
  }

  <div class="flex justify-content-end gap-2 pt-4">
    <p-button
      type="button"
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      [disabled]="enviando()"
      (onClick)="onDialogoEnviarVisible(false)"
    />
    <p-button
      type="button"
      label="Aceptar"
      [disabled]="!liderDestino() || enviando()"
      [loading]="enviando()"
      (onClick)="aceptarTransferencia()"
    />
  </div>
</p-dialog>